import { useTranslation } from 'react-i18next'


export default function Hero2() {

    const [t, i18n] = useTranslation('global')

    return (
        <section id="hero2" className='pb-5 pt-5'  style={{ backgroundColor: '#e5e5e5' }}>
            <div className='row justify-content-center'>
                <div className='col-10 col-lg-10'>
                    <article className='text-center'>
                        <h4 className='text-center fw-bold fs-1' style={{ color: '#4e4e4e' }}>
                            {t('home.hero2.title')}
                        </h4>
                        <p className='text-center fw-bold fs-2' style={{ color: '#4e4e4e' }}>
                            {t('home.hero2.subtitle')}
                        </p>
                    </article>
                </div>
            </div>
        </section>
    )
}